import { Component, Input } from '@angular/core';
import { UserContext } from '@core/models';
import { fadeInOut } from '@shared/animations';
import { Table } from '@shared/models';

@Component({
  selector: 'sp-dashboard-accordion',
  templateUrl: 'dashboard-accordion.component.html',
  styleUrls: ['./dashboard-accordion.component.scss'],
  animations: [fadeInOut],
})
export class DashboardAccordionComponent {
  @Input() tableData: Table;
  @Input() userContext: UserContext;
}
